import { render, staticRenderFns } from "./Quickview.vue?vue&type=template&id=5862ae0a&"
import script from "./Quickview.vue?vue&type=script&lang=js&"
export * from "./Quickview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports